import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import Api from "../../api/Api";
import { useNavigate } from "react-router-dom";

const OTP_LENGTH = 6;
const RESEND_SECONDS = 60;

export default function OtpModal({ isOpen, onClose, onVerify, destination = "o teu email" }) {
  const [digits, setDigits] = useState(Array(OTP_LENGTH).fill(""));
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [resendTimer, setResendTimer] = useState(RESEND_SECONDS);
  const inputRefs = useRef([]);
    const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) return;
    setDigits(Array(OTP_LENGTH).fill(""));
    setError("");
    setSuccess(false);
    setResendTimer(RESEND_SECONDS);
    setTimeout(() => inputRefs.current[0]?.focus(), 100);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen || resendTimer <= 0) return;
    const t = setTimeout(() => setResendTimer(s => s - 1), 1000);
    return () => clearTimeout(t);
  }, [resendTimer, isOpen]);

  if (!isOpen) return null;

  // Extracts only digits from any pasted/typed string, e.g. "123-456" -> "123456"
  const sanitizeDigits = (str) => str.replace(/\D/g, "");

  const distributeCode = (rawCode, startIndex = 0) => {
    const clean = sanitizeDigits(rawCode).slice(0, OTP_LENGTH - startIndex);
    if (!clean) return;

    setDigits(prev => {
      const next = [...prev];
      for (let i = 0; i < clean.length; i++) {
        next[startIndex + i] = clean[i];
      }
      return next;
    });

    const lastFilledIndex = Math.min(startIndex + clean.length, OTP_LENGTH) - 1;
    const focusIndex = Math.min(lastFilledIndex + 1, OTP_LENGTH - 1);
    setTimeout(() => inputRefs.current[focusIndex]?.focus(), 0);
    setError("");
  };

  const handleChange = (index, value) => {
    // Se o utilizador escrever/colar vários caracteres num único input (ex: cola "123-456"
    // diretamente no primeiro campo), distribuímos automaticamente por todos os inputs.
    const clean = sanitizeDigits(value);

    if (clean.length > 1) {
      distributeCode(clean, index);
      return;
    }

    setDigits(prev => {
      const next = [...prev];
      next[index] = clean;
      return next;
    });
    setError("");

    if (clean && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (index, e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text");
    distributeCode(pasted, index);
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (digits[index]) {
        setDigits(prev => {
          const next = [...prev];
          next[index] = "";
          return next;
        });
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
        setDigits(prev => {
          const next = [...prev];
          next[index - 1] = "";
          return next;
        });
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleClose = () => {
    setDigits(Array(OTP_LENGTH).fill(""));
    setError("");
    setSuccess(false);
    onClose();
  };

  const handleVerify = async () => {
    const code = digits.join("");
    if (code.length < OTP_LENGTH) {
      setError("Introduz o código completo de 6 dígitos.");
      return;
    }
        setLoading(true);
const formattedCode = code.replace(/(\d{3})(\d{3})/, "$1-$2");

  const response = await Api.validateOPT({ code:formattedCode });
    

        console.log(response);
if(response.status===420){
  setError("Código OTP inválido.");
}
   else{
     
    setSuccess(true);
            localStorage.setItem("user", JSON.stringify(response.user));
         localStorage.setItem("loginTime", Date.now());
             navigate("/home");
   }


      setLoading(false);
    /*
    setError("");

    await new Promise(r => setTimeout(r, 1000));
    setLoading(false);
    setSuccess(true);
    if (onVerify) onVerify(code);*/
  };

  const handleResend =async () => {
    if (resendTimer > 0) return;
    setResendTimer(RESEND_SECONDS);
    setDigits(Array(OTP_LENGTH).fill(""));
    inputRefs.current[0]?.focus();


 
  const response = await Api.resendOTP({ email:destination });

    if(!response.success){
        toast.error("Erro ao enviar OPT"); 
    }
   

  
  };

  const isComplete = digits.every(d => d !== "");

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(2, 11, 26, 0.72);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          font-family: 'Inter', sans-serif;
          animation: overlayFade 0.25s ease;
          padding: 20px;
        }

        @keyframes overlayFade {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .otp-modal {
          background: #ffffff;
          border-radius: 20px;
          width: min(440px, 92vw);
          padding: 40px 36px;
          position: relative;
          box-shadow: 0 32px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(0,174,255,0.1);
          animation: modalPop 0.35s cubic-bezier(.22,1,.36,1);
          text-align: center;
        }

        @keyframes modalPop {
          from { opacity: 0; transform: translateY(20px) scale(0.96); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }

        .otp-close {
          position: absolute;
          top: 18px;
          right: 18px;
          background: #f5f9fd;
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #8aa0b6;
          transition: background 0.2s, color 0.2s;
        }
        .otp-close:hover { background: #e2eaf0; color: #1a2b3c; }

        .otp-icon-wrap {
          width: 64px;
          height: 64px;
          border-radius: 18px;
          background: linear-gradient(135deg, #00aaff 0%, #0044ee 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 22px;
          box-shadow: 0 10px 28px rgba(0,100,255,0.35);
        }

        .otp-title {
          font-size: 1.4rem;
          font-weight: 700;
          color: #0d1b2a;
          margin-bottom: 8px;
          letter-spacing: -0.02em;
        }

        .otp-subtitle {
          font-size: 0.85rem;
          color: #7a8fa6;
          margin-bottom: 32px;
          line-height: 1.5;
        }

        .otp-subtitle strong { color: #1a2b3c; font-weight: 600; }

        .otp-inputs-row {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin-bottom: 10px;
        }

        .otp-input {
          width: 50px;
          height: 58px;
          border-radius: 12px;
          border: 1.5px solid #e2eaf0;
          background: #f5f9fd;
          font-size: 1.4rem;
          font-weight: 700;
          text-align: center;
          color: #0d1b2a;
          font-family: 'Inter', sans-serif;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s, background 0.2s, transform 0.15s;
        }

        .otp-input:focus {
          border-color: #0090e7;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(0,144,231,0.15);
          transform: translateY(-2px);
        }

        .otp-input.otp-filled {
          border-color: #00aaff;
          background: #eef8ff;
          color: #0044ee;
        }

        .otp-input.otp-error {
          border-color: #ef4444;
          background: #fef2f2;
          animation: shake 0.4s ease;
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }

        /* Divider between groups of 3, mirrors XXX-XXX format */
        .otp-dash {
          display: flex;
          align-items: center;
          color: #c5d3e0;
          font-size: 1.3rem;
          font-weight: 300;
          padding: 0 2px;
        }

        .otp-error-text {
          font-size: 0.78rem;
          color: #ef4444;
          margin-bottom: 18px;
        }

        .otp-hint {
          font-size: 0.72rem;
          color: #a8bfcf;
          margin-bottom: 28px;
        }

        .otp-btn {
          width: 100%;
          height: 52px;
          border-radius: 12px;
          border: none;
          cursor: pointer;
          font-size: 0.95rem;
          font-weight: 600;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: #fff;
          background: linear-gradient(135deg, #00aaff 0%, #0044ee 100%);
          box-shadow: 0 6px 24px rgba(0,100,255,0.35);
          transition: transform 0.18s, box-shadow 0.18s, filter 0.18s, opacity 0.18s;
          font-family: 'Inter', sans-serif;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .otp-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 32px rgba(0,100,255,0.5);
          filter: brightness(1.08);
        }

        .otp-btn:disabled { opacity: 0.5; cursor: not-allowed; }

        .otp-spinner {
          width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,0.4);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }

        .otp-resend {
          margin-top: 22px;
          font-size: 0.82rem;
          color: #8aa0b6;
        }

        .otp-resend button {
          background: none;
          border: none;
          color: #0077cc;
          font-weight: 600;
          cursor: pointer;
          font-size: 0.82rem;
          font-family: 'Inter', sans-serif;
        }
        .otp-resend button:hover:not(:disabled) { text-decoration: underline; }
        .otp-resend button:disabled {
          color: #b0c2d0;
          cursor: not-allowed;
        }

        .otp-success-icon {
          width: 72px; height: 72px;
          border-radius: 50%;
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 22px;
          box-shadow: 0 10px 28px rgba(34,197,94,0.35);
          animation: successPop 0.5s cubic-bezier(.22,1,.36,1);
        }
        @keyframes successPop {
          0% { transform: scale(0); }
          60% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }

        @media (max-width: 420px) {
          .otp-input { width: 40px; height: 50px; font-size: 1.15rem; }
          .otp-inputs-row { gap: 6px; }
        }
      `}</style>

      <div className="modal-overlay" onClick={handleClose}>
        <div className="otp-modal" onClick={e => e.stopPropagation()}>
          <button className="otp-close" onClick={handleClose} aria-label="Fechar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          {!success ? (
            <>
              <div className="otp-icon-wrap">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="5" y="2" width="14" height="20" rx="2"/>
                  <line x1="12" y1="18" x2="12.01" y2="18"/>
                </svg>
              </div>

              <div className="otp-title">Autenticação de dois factores</div>
              <div className="otp-subtitle">
                Introduz o código de 6 dígitos enviado para <strong>{destination}</strong>
              </div>

              <div className="otp-inputs-row">
                {digits.slice(0, 3).map((digit, i) => (
                  <input
                    key={i}
                    ref={el => (inputRefs.current[i] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength={OTP_LENGTH}
                    className={`otp-input ${digit ? "otp-filled" : ""} ${error ? "otp-error" : ""}`}
                    value={digit}
                    onChange={e => handleChange(i, e.target.value)}
                    onKeyDown={e => handleKeyDown(i, e)}
                    onPaste={e => handlePaste(i, e)}
                    onFocus={e => e.target.select()}
                  />
                ))}

                <span className="otp-dash">—</span>

                {digits.slice(3, 6).map((digit, i) => {
                  const realIndex = i + 3;
                  return (
                    <input
                      key={realIndex}
                      ref={el => (inputRefs.current[realIndex] = el)}
                      type="text"
                      inputMode="numeric"
                      maxLength={OTP_LENGTH}
                      className={`otp-input ${digit ? "otp-filled" : ""} ${error ? "otp-error" : ""}`}
                      value={digit}
                      onChange={e => handleChange(realIndex, e.target.value)}
                      onKeyDown={e => handleKeyDown(realIndex, e)}
                      onPaste={e => handlePaste(realIndex, e)}
                      onFocus={e => e.target.select()}
                    />
                  );
                })}
              </div>

              {error && <div className="otp-error-text">{error}</div>}

              <div className="otp-hint">
                Dica: podes colar o código completo (ex: 123-456) em qualquer campo
              </div>

              <button
                className="otp-btn"
                onClick={handleVerify}
                disabled={loading || !isComplete}
              >
                {loading && <span className="otp-spinner" />}
                {loading ? "A verificar..." : "Verificar código"}
              </button>

              <div className="otp-resend">
                {resendTimer > 0 ? (
                  <>Reenviar código em <strong>{resendTimer}s</strong></>
                ) : (
                  <>Não recebeste? <button onClick={handleResend}>Reenviar código</button></>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="otp-success-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <div className="otp-title">Código verificado!</div>
              <div className="otp-subtitle">A tua identidade foi confirmada com sucesso.</div>
              <button className="otp-btn" onClick={handleClose}>Continuar</button>
            </>
          )}
        </div>
      </div>
    </>
  );
}